import { render, staticRenderFns } from "./ServicerFormModal.vue?vue&type=template&id=7ffdf8a8"
import script from "./ServicerFormModal.ts?vue&type=script&lang=ts&external"
export * from "./ServicerFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffdf8a8')) {
      api.createRecord('7ffdf8a8', component.options)
    } else {
      api.reload('7ffdf8a8', component.options)
    }
    module.hot.accept("./ServicerFormModal.vue?vue&type=template&id=7ffdf8a8", function () {
      api.rerender('7ffdf8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/ServicerFormModal.vue"
export default component.exports